import React, { useState } from 'react';
import { MdOutlineEmail } from 'react-icons/md';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Apis from '../../api';
import { HEADERMENU_PATH } from '../../routes/RoutesURL';
import HSButton from '../common/Button';
import InputToolTip from '../common/InputTooltip';
import NormalInput from '../common/NormalInput';
import MessageActions from '../message/redux/actions';
import { emailValidation } from '../utils/validation';

const ForgotPassword: React.FC = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [email, setEmail] = useState<string | undefined>(undefined);
    const [isValidate, setIsvalidate] = useState(false);
    const [loader, setLoader] = useState(false);

    const onFieldChange = (data: { name: string; value?: number | string }) => {
        const { value, name } = data;
        setEmail(name === 'email' ? (value ? String(value).toLowerCase() : String(value)) : String(value));
    };

    const onClickResetEmailPassword = () => {
        setIsvalidate(true);
        if (!email || email.trim() === '' || !emailValidation(email)) {
            return;
        }
        setIsvalidate(false);
        setLoader(true);
        Apis.resendResetPasswordEmail({
            email: email.trim(),
        })
            .then(() => {
                navigate(HEADERMENU_PATH.forgotPasswordMessage, { state: { email: email } });
            })
            .catch((err) => {
                dispatch(MessageActions.showMessage({ error: true, text: String(err) }));
            })
            .finally(() => {
                setLoader(false);
                setEmail(undefined);
            });
    };

    return (
        <div className="h-full flex justify-center items-center">
            <div className="w-full" id="login">
                <div>
                    <div className="border">
                        <InputToolTip title={'Email'}>
                            <NormalInput
                                error={isValidate && (!email || !emailValidation(email))}
                                placeholder="Email"
                                value={email}
                                onChange={onFieldChange}
                                name="email"
                                bordered={false}
                                prefix={<MdOutlineEmail color="rgb(196, 196, 196)" size={'1rem'} />}
                                isRequired
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter') {
                                        onClickResetEmailPassword();
                                    }
                                }}
                            />
                            {isValidate && (!email || !emailValidation(email)) && (
                                <div className="common_error px-3">Please enter valid email</div>
                            )}
                        </InputToolTip>
                    </div>
                    <div className="flex justify-center items-center py-4 flex-col">
                        <HSButton
                            title="Send Reset password Email"
                            loading={loader}
                            onClick={onClickResetEmailPassword}
                        />
                        <HSButton
                            title="Return to Log in"
                            type="link"
                            onClick={() => navigate(HEADERMENU_PATH.login)}
                            className="mt-2 text-base underline text-black hover:text-black underline_b"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
